import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/boat/src/components/auth/sign-up.tsx");
